import React from 'react';
import Styles from './ModalInsuranceDetails.css';
import ContainerHome24 from '../../../../components/atoms/ContainerHome24';
import { useSimuladorEnergiaSolarState } from '../../model/state';
import Modal from '../../widgets/Modal/Modal';
import Button from '../../widgets/Button/Button';
import { useScroll } from '../../../../utils/useLayout';

const Wrapper = ({ children, modal = false, setOpen, open }) => {
  if (modal) {
    return (
      <Modal open={open} setOpen={setOpen} contentFill>
        {children}
      </Modal>
    );
  }

  return <>{children}</>;
};

function ModalInsuranceDetails() {
  const { dynamicScrollTo } = useScroll();
  const { modalInsuranceDetails, setModalInsuranceDetails, isMobile } =
    useSimuladorEnergiaSolarState();

  const closeModal = () => {
    setModalInsuranceDetails(false);
    dynamicScrollTo(isMobile ? '.proposal .insurance' : '.proposal .protection');
  };

  if (!modalInsuranceDetails) return null;

  return (
    <Wrapper
      modal={!isMobile}
      open={!!modalInsuranceDetails}
      setOpen={(value) => {
        if (!value) {
          closeModal();
          return;
        }

        setModalInsuranceDetails(value);
      }}
    >
      {isMobile && (
        <div className="modal-insurance-details-header">
          <ContainerHome24>
            <p>Mostrar detalhes</p>
            <Button variant="flat" className="modal-widget-close" onClick={closeModal}>
              <img alt="" src="assets/simulador-energia-solar/jornada/ic-close-side-modal.svg" />
            </Button>
          </ContainerHome24>
        </div>
      )}
      <div className="modal-insurance-details">
        <ContainerHome24>
          <p className="text-title-desk">Mostrar detalhes</p>
          <p className="text-title">{modalInsuranceDetails?.label}</p>
          <b className="text-cover">Coberturas inclusas</b>

          {modalInsuranceDetails?.benefits?.map((benefit) => (
            <div className="benefit-row" key={`benefit-${benefit}`}>
              <div>
                <img alt="" src="assets/simulador-energia-solar/jornada/ic-check.svg" />
              </div>
              <p className="benefit-text">{benefit}</p>
            </div>
          ))}
        </ContainerHome24>
      </div>
      <style jsx>{Styles}</style>
    </Wrapper>
  );
}

export default ModalInsuranceDetails;
